import React, { useEffect, useState } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '@/common/SafeIcon';
import Breadcrumbs from '@/components/common/Breadcrumbs';
import StatusBadge from '@/components/common/StatusBadge';
import { getBuildingById, getFloorsByBuilding } from '@/services/nocodeBackendService';

const { FiLayers, FiArrowLeft } = FiIcons;

const BuildingDetails = () => {
  const { buildingId } = useParams();
  const navigate = useNavigate();
  const [building, setBuilding] = useState(null);
  const [floors, setFloors] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([
      getBuildingById(buildingId),
      getFloorsByBuilding(buildingId)
    ])
    .then(([bData, fData]) => {
      setBuilding(bData);
      setFloors(fData);
    })
    .catch(() => navigate('/accommodation'))
    .finally(() => setLoading(false));
  }, [buildingId, navigate]);

  if (loading) return <div className="p-12 text-center text-slate-500">Loading building details...</div>;
  if (!building) return null;

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <Breadcrumbs items={[
        { label: 'Accommodation', path: '/accommodation' },
        { label: building.name }
      ]} />
      
      <div className="mb-8 flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold text-slate-900 flex items-center gap-3">
            <button onClick={() => navigate(-1)} className="text-slate-400 hover:text-slate-600 transition-colors">
              <SafeIcon icon={FiArrowLeft} />
            </button>
            {building.name}
          </h1>
          <p className="text-slate-600 mt-2 ml-10">Select a floor to view available rooms.</p>
        </div>
        <StatusBadge status={building.status} />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {floors.map(floor => (
          <Link 
            key={floor.id} 
            to={`/accommodation/${building.id}/floor/${floor.id}`}
            className="bg-white p-6 rounded-xl shadow-sm border border-slate-200 hover:shadow-md hover:border-sky-300 transition-all group flex flex-col items-center text-center"
          >
            <div className="w-12 h-12 bg-sky-50 text-sky-600 rounded-full flex items-center justify-center mb-4 group-hover:bg-sky-100 transition-colors">
              <SafeIcon icon={FiLayers} className="w-6 h-6" />
            </div>
            <h3 className="font-bold text-slate-800">{floor.floor_name}</h3>
            <span className="text-xs text-slate-500 mt-2 capitalize">{floor.status}</span>
          </Link>
        ))}
      </div>
      
      {floors.length === 0 && (
        <div className="text-center py-12 bg-white rounded-xl border border-slate-200 text-slate-500">
          No floors have been added to this building yet.
        </div>
      )}
    </div>
  );
};

export default BuildingDetails;